import { BaseLinkConf } from './base-link-conf';

export class MenuLinkConf extends BaseLinkConf {
  urlPath: string;
  // Standalone means that it is not part of a module.
  standalone = false;

  constructor(init?: Partial<MenuLinkConf>) {
    super(init);
    Object.assign(this, init);
  }
}
